<div style="padding: 15px;">
  <div class="table-title">
     <h3>Tiktok Posts</h3>
  </div>
</div>

<form nz-form [formGroup]="filtersForm" class="filter-form">
  <div nz-row [nzGutter]="16">
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Politician / Hashtag</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="politician" 
               nzShowSearch 
               nzAllowClear 
               nzPlaceHolder="Zgjidh politikanin">
            <nz-option
              *ngFor="let politician of politicians"
              [nzValue]="politician.id"
              [nzLabel]="politician.name"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Attacked</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="attackedPolitician" nzShowSearch nzAllowClear
            nzPlaceHolder="Politikani i sulmuar">
            <nz-option *ngFor="let politician of attackedPoliticians" [nzValue]="politician.id"
              [nzLabel]="politician.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Post Type</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="postType"
                      nzShowSearch 
                      nzAllowClear 
                      nzPlaceHolder="Kategoria e postimit">
            <nz-option
              *ngFor="let type of types"
              [nzValue]="type.id"
              [nzLabel]="type.type"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

    <div nz-row [nzGutter]="16">
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Topic</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="topic" nzShowSearch nzAllowClear nzPlaceHolder="Tematika/ Fushata">
            <nz-option *ngFor="let topic of topics" [nzValue]="topic.id" [nzLabel]="topic.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Search text</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="searchBox" placeholder="Search by any keyword" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzSpan]="8" class="search-button">
      <nz-form-item>
      &nbsp;&nbsp;
        <nz-form-control>
          <button nz-button nzType="primary" (click)="search()">
            <fa-icon [icon]="faSearch"></fa-icon> &nbsp;Filter
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</form>

<div class="table-container">
  <nz-table
    #basicTable
    nzSize="middle"
    [nzData]="posts"
    [nzFrontPagination]="false"
    [nzLoading]="isDataLoading"
    [nzTotal]="totalCount"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageNumber"
    [nzPageSizeOptions]="pageSizeOptions"
    [nzShowSizeChanger]="true"
    [nzShowQuickJumper]="true"
    [nzShowPagination]="true"
    (nzQueryParams)="onQueryParamsChange($event)"
  >
    <thead>
      <tr>
       <th nzWidth="150px">Politician</th>
        <th>Post content</th>
        <th nzWidth="100px">Date</th>
        <th>Attacked politician</th>
        <th>Post type</th>
        <th>Topic / Campaign</th>
        <th nzWidth="80px">Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (post of basicTable.data; track post) {
      <tr>
        <td>{{ post.politician?.name }}</td>
        <td>{{ post.description }}...</td>
        <td>{{ post.createdAt| date: 'dd.MM.yyyy' }}</td>
        
        <!-- Attacked Politician column with inline edit -->
        <td>
         @if (!editCache[post.id].edit) {
           <span style="color: #ff4d4f;">{{ post.attackedPolitician }}</span>
         } @else {
         <input nz-input
            [(ngModel)]="editCache[post.id].data.attackedPolitician"
            [nzAutocomplete]="auto"
            (input)="onAttackedPoliticianInput($any($event.target).value)"
            (ngModelChange)="onAttackedPoliticianChange($event, post.id)"
            style="width: 100%;"
            placeholder="Search or type politician name"/>
        <nz-autocomplete nzBackfill #auto>
           @for (politician of filteredAttackedPoliticians; track politician.name) {
              @if (politician.name != "All") { <!-- Skip "All" option -->
                  <nz-auto-option [nzValue]="politician.name" [nzLabel]="politician.name">
                    {{ politician.name }}
                  </nz-auto-option>
              }
            }
        </nz-autocomplete>
      }
     </td>
        
        <!-- Post Type column with inline edit -->
        <td>
          @if (!editCache[post.id].edit) {
            {{ post?.type?.type }}
          } @else {
            <nz-select 
                  [(ngModel)]="editCache[post.id].data.typeId" 
                  nzShowSearch 
                  nzAllowClear
                  (ngModelChange)="onPostTypeChange($event, post.id)"
                  style="width: 100%;">
              @for (type of types; track type) {
                @if (type.id !== 0) { <!-- Skip "All" and "Unspecified" options -->
                  <nz-option
                    [nzValue]="type.id"
                    [nzLabel]="type.type"
                  ></nz-option>
                }
              }
            </nz-select>
          }
        </td>
        
        <!-- Topic/Campaign column with inline edit -->
        <td>
          @if (!editCache[post.id].edit) {
              {{ post?.topic?.name }}
          } @else {
            <nz-select 
                   [(ngModel)]="editCache[post.id].data.topicId" 
                   nzShowSearch 
                   nzAllowClear 
                   style="width: 100%;">
              @for (topic of topics; track topic) {
                @if (topic.id !== 0) { <!-- Skip "All" and "Unspecified" options -->
                  <nz-option
                    [nzValue]="topic.id"
                    [nzLabel]="topic.name"
                  ></nz-option>
                }
              }
            </nz-select>
          }
        </td>
        
        <!-- Action buttons -->
        <td class="action-buttons">
          @if (!editCache[post.id].edit) {
            <button nz-button nzType="primary" nzShape="round" (click)="openPostDetails(post.id)">
              <fa-icon [icon]="faView"></fa-icon>
            </button>
            
            <button nz-button nzType="default" nzShape="round" (click)="startEdit(post.id)">
              <fa-icon [icon]="faEdit"></fa-icon>
            </button>
          } @else {
            <button nz-button nzType="primary" nzDanger nzShape="round" (click)="saveEdit(post.id, editCache[post.id].data.attackedPolitician ??'-1', editCache[post.id].data.typeId ??-1, editCache[post.id].data.topicId??-1)" class="save-btn">
              <fa-icon [icon]="faSave"></fa-icon>
            </button>
            
            <button 
              nz-button 
              nzType="default" 
              nzShape="round" 
              nz-popconfirm 
              nzPopconfirmTitle="Sure to cancel?" 
              (nzOnConfirm)="cancelEdit(post.id)"
            >
            <fa-icon [icon]="faCancel"></fa-icon>
            </button>
          }
        </td>
      </tr>
    }
    </tbody>
  </nz-table>
</div>